import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=3fc9c963&"
import script from "./InfoSection.vue?vue&type=script&lang=js&"
export * from "./InfoSection.vue?vue&type=script&lang=js&"
import style0 from "./InfoSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InfoSection.vue"
export default component.exports